import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getMeasurerConfiguration } from "../Actions/API/AppInstance/AppInstanceActions"
import { APIAppMeasurerConfiguration } from "../Models/API/APIAppMeasurerConfiguration"

export function useAppMeasurerConfiguration(
    appID?: string
): FetchState<APIAppMeasurerConfiguration> {
    const dispatch = useDispatch()
    const fetchState = useAppState(state => {
        if (appID === undefined) {
            return undefined
        }

        return state.api.apps.measurerConfiguration[appID]
    })

    useEffect(() => {
        if (appID === undefined || fetchState !== undefined) {
            return
        }

        dispatch(getMeasurerConfiguration(appID))
    }, [appID, fetchState, dispatch])

    return fetchState
}
